<template>

  <div>
    <div class="sm:hidden mb-4">
      <label class="sr-only" for="tabs">Select a tab</label>
      <select id="tabs" v-model="selectTabValueName"
              class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md" name="tabs">
        <option v-for="tab in tabs" :value="tab.name">{{ tab.name }}</option>
      </select>
    </div>
    <div class="hidden sm:block mb-4">
      <nav aria-label="Tabs" class="flex space-x-4">

        <a v-for="tab in tabs"
           :class='{ "text-gray-500 hover:text-gray-700": !tab.isActive, "bg-brand bg-opacity-5 text-brand": tab.isActive }'
           class="px-3 py-2 font-medium text-sm rounded-md"
           href="#"
           @click.prevent="selectTab(tab)">
          {{ tab.name }}
        </a>

      </nav>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>

</template>

<script>
    export default {
      data() {
        return {
          tabs: [],
          selectTabValueName: ''
        }
      },
      watch:{
        selectTabValueName(newValue){
          let that = this;
          this.tabs.forEach(tab => {
            if(tab.name === newValue){
              this.selectTab(tab);
            }
          });
        }
      },
      computed: {},
      methods: {
        selectTab(selectedTab) {
          let that = this;
          this.tabs.forEach(tab => {
            if (tab.name === selectedTab.name) {
              tab.isActive = true;
            } else {
              tab.isActive = false;
            }
            if(that.selectTabValueName !== selectedTab.name){
              that.selectTabValueName = selectedTab.name;
            }
          });
        }
      },
      created() {
        this.tabs = this.$children;
      },
      mounted() {
        let that = this;
        eventBus.$on('select-local-tab-by-index', function (index) {
          if (index >= 0 && index < this.tabs.length) {
            // The element exists! Select it!
            that.selectTab(this.tabs[index]);
          }
        });
        if (!_.isUndefined(_.head(this.tabs))) {
          this.selectTab(_.head(this.tabs));
        }
      }
    }
</script>
